import React, { useState } from "react";
import { connect } from "react-redux";
import { Flex } from "/app/src/component";
import DateTime from "/app/src/lib/DateTime";

import CompanyModel from "/app/src/model/Company/model";

import { companySelector } from "/app/src/selectors";

import CompanyDetails from "./CompanyDetails";
import _ from "lodash";

class CompanyComponent extends React.Component {
  render() {
    let { company, onClick, selected } = this.props;
    let status = companySelector.getPaymentStatus(company);
    if (status === "trial") {
      status = company.payment_status.days_left_in_trial;
    }
    let nbrRegisterEmployee = 0;
    company.employees.forEach((emp) => {
      if (emp.verified) nbrRegisterEmployee += 1;
    });

    const border =
      selected === company.id ? "2px solid black" : "2px solid transparent";
    return (
      <Flex
        border={border}
        w="100%"
        onClick={onClick}
        shrink={0}
        wrap
        my="10px"
        cursor="pointer"
      >
        <Flex padding="5px 10px" w="40px" column>
          <strong>id</strong> {company.id}
        </Flex>
        <Flex padding="5px 10px" w="200px" column>
          <strong>Namn</strong> {company.name}
        </Flex>
        <Flex padding="5px 10px" w="100px" column>
          <strong>Ärende</strong> {company.nbr_tickets}
        </Flex>
        <Flex padding="5px 10px" w="100px" column>
          <strong>Användare</strong> {nbrRegisterEmployee}
        </Flex>
        <Flex padding="5px 10px 5px 30px" w="200px" column>
          <strong>Registera</strong>
          {DateTime.getNiceDate(company.date_created)} (
          {DateTime.getDiffFromToday(company.date_created)} days)
        </Flex>
        <Flex padding="5px 10px 5px 30px" w="200px" column>
          <strong>Plan</strong>
          <Flex>
            {_.get(company, "payment_status.plan.name", "not found")}{" "}
            {_.get(company, "payment_status.plan.cost_per_user", "not found")}:-
          </Flex>
        </Flex>
        <Flex padding="5px 10px 5px 30px" w="200px" column>
          <strong>Employees</strong>
          {company.employees.map((em) => {
            return <Flex key={em.id}>{em.email}</Flex>;
          })}
        </Flex>
      </Flex>
    );
  }
}

const CompanyList = ({ companies, header, setSelected, selected }) => {
  const [fold, setFold] = useState(false);

  let nbrEmployees = 0;
  let nbrProMonthlyPackage = 0;
  let nbrProYearlyPackage = 0;
  let nbrStandardMonthlyPackage = 0;
  let nbrStandardYearlyPackage = 0;

  const standards = ["standard", "start"];

  const list = companies.map((company) => {
    nbrEmployees += company.employees.length;
    const plan = _.get(company, "payment_status.plan.package", "no plan");
    const subscription = _.get(
      company,
      "payment_status.plan.subscription",
      "no subscription"
    );
    if (plan === "pro" && subscription === "monthly") {
      nbrProMonthlyPackage += 1;
    } else if (plan === "pro" && subscription === "yearly") {
      nbrProYearlyPackage += 1;
    } else if (standards.includes(plan) && subscription === "yearly") {
      nbrStandardYearlyPackage += 1;
    } else if (standards.includes(plan) && subscription === "monthly") {
      nbrStandardMonthlyPackage += 1;
    }
    return (
      <CompanyComponent
        selected={selected}
        key={company.id}
        company={company}
        onClick={() => {
          setSelected(company.id);
        }}
      />
    );
  });
  /**
   * 
   * color: bisque;
    background: cadetblue;
    font-size: 19px;
    font-family: sans-serif;
    border-bottom: 2px solid white;
   * 
   */
  return (
    <React.Fragment>
      <Flex
        bg="cadetblue"
        color="bisque"
        fontSize="18px"
        fontFamily="sans-serif"
        shrink={0}
        padding="16px"
        borderBottom="2px solid whitesmoke"
        center
        onClick={() => {
          setFold(!fold);
        }}
        cursor="pointer"
      >
        <Flex column>
          <Flex>
            <b>{header}</b>
          </Flex>
          <Flex>
            {companies.length} companies {nbrEmployees} employees
          </Flex>
          <Flex>
            {nbrStandardMonthlyPackage !== 0 &&
              `standard: ${nbrStandardMonthlyPackage} monthly`}
            {nbrStandardYearlyPackage !== 0 &&
              ` ${nbrStandardYearlyPackage} yearly`}
          </Flex>
          <Flex>
            pro: {nbrProMonthlyPackage} monthly {nbrProYearlyPackage} yearly
          </Flex>
        </Flex>
        <Flex marginLeft="auto" cursor="pointer" fontSize="20px">
          {fold ? "Expand" : "Collapse"}
        </Flex>
      </Flex>
      <Flex
        style={{
          display: fold ? "none" : "flex",
          flexDirection: "column-reverse",
        }}
        column
      >
        {list}
      </Flex>
    </React.Fragment>
  );
};

class DashboardOverview extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: false,
    };
  }
  componentDidMount() {
    this.props.dispatch(CompanyModel.companiesOverviewPost());
  }

  render() {
    let companies = this.props.companies.toJS();
    let standard = [];
    let pro = [];
    let cancel = [];
    let trial = [];
    let trial_end = [];
    let error = [];
    _.each(companies, (c) => {
      switch (c.payment_status.status) {
        case "normal":
          if (
            c.payment_status.plan.package === "standard" ||
            c.payment_status.plan.package === "start"
          ) {
            standard.push(c);
          } else if (c.payment_status.plan.package === "pro") {
            pro.push(c);
          } else {
            error.push(c);
          }
          break;
        case "trial":
          trial.push(c);
          break;
        case "trial_end":
          trial_end.push(c);
          break;
        case "cancel":
          cancel.push(c);
          break;
        default:
          error.push(c);
      }
    });
    const setSelected = (id) => {
      this.setState({ selected: id });
    };

    return (
      <Flex grow width="100%" h="100%">
        <Flex grow h="100%" overflow="scroll" column>
          <CompanyList
            companies={trial}
            header="Trial"
            setSelected={setSelected}
            selected={this.state.selected}
          />
          <CompanyList
            companies={trial_end}
            header="Trial Ended"
            setSelected={setSelected}
            selected={this.state.selected}
          />
          <CompanyList
            companies={standard}
            header="Standard and Start"
            setSelected={setSelected}
            selected={this.state.selected}
          />
          <CompanyList companies={pro} header="Pro" setSelected={setSelected} />
          <CompanyList
            companies={cancel}
            header="Cancel and Trial Ended"
            setSelected={setSelected}
            selected={this.state.selected}
          />
          <CompanyList
            companies={error}
            header="There are problem with these"
            setSelected={setSelected}
            selected={this.state.selected}
          />
        </Flex>

        <Flex w="400px" h="100%" overflowY="scroll" shrink={0}>
          <CompanyDetails
            selected={this.state.selected}
            companies={companies}
          />
        </Flex>
      </Flex>
    );
  }
}
export default connect((state) => {
  return {
    companies: companySelector.companiesOverview(state),
  };
})(DashboardOverview);



// WEBPACK FOOTER //
// src/layout/Dashboard/MainPanel/Overview/Overview.js